import React from 'react';
import '../Styles/Header.css';

function Header() {
    return (
        <div className="Header-Container">
            <ul className="List">
                <li><a className="ListItem" href="#aboutme">About Me</a></li>
                <li><a className="ListItem" target="_blank" rel="noopener noreferrer" href="https://github.com/jetonkoka">Github</a></li>
                <li><a className="ListItem" target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/jetonkoka/">LinkedIn</a></li>
                <li><a className="ListItem" href="#contact">Hire Me</a></li>
            </ul>
        </div>
    )
}
export default Header;


// WEBPACK FOOTER //
// ./src/Components/Header.js